// extracted by css-extract-rspack-plugin
export default {"curtain":"OaaYGJ"};